import React, { useEffect, useState } from "react";
import { languageHelper } from "../../../../config/helperFunctions";
import CardTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";

function LoyaltyPointsReport() {
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Customer Name") || "Customer Name",
      accessorKey: "name",
    },
    {
      header: languageHelper("Phone") || "Phone",
      accessorKey: "phone",
    },
    {
      header: languageHelper("Earned Points") || "Earned Points",
      cell: (row) =>
        (
          Number(row.row.original.loyalty_points) +
          Number(row.row.original.orders_sum_loyalty_point_amount)
        ).toFixed(2),
    },
    {
      header: languageHelper("Spent Points") || "Spent Points",
      accessorKey: "orders_sum_loyalty_point_amount",
    },
    {
      header: languageHelper("Remaining Point") || "Remaining Point",
      accessorKey: "loyalty_points",
    },
  ];
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/loyalty-report`)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <main className="my-16">
      <CardTable2
        heading={languageHelper("Loyalty Point Report")}
        columns={columns}
        data={data}
        hideDates={true}
      />
    </main>
  );
}

export default LoyaltyPointsReport;
